import React, { useEffect } from 'react';
import { Chart } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
let myBarChart;

const BarChart = () => {
  const richLists = useSelector((state) => state.richLists);
  const { sectors, activeList } = richLists;

  let barChartRef = React.createRef();

  useEffect(() => {
    buildBarChart();
  });

  const buildBarChart = () => {
    const myBarChartRef = barChartRef.current.getContext('2d');
    if (typeof myBarChart !== 'undefined') myBarChart.destroy();

    let [currentSectors] = sectors.filter(
      (x) => JSON.stringify(Object.keys(x)) === JSON.stringify([activeList])
    );
    let barData = Object.values(currentSectors)[0];

    myBarChart = new Chart(myBarChartRef, {
      type: 'horizontalBar',
      options: {
        legend: {
          display: false,
        },
        animation: false,
        responsive: true,
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItems, data) {
              return `${tooltipItems.xLabel} Rich List Entries`;
            },
          },
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                userCallback: function (label, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                    return label;
                  }
                },
              },
            },
          ],
        },
      },
      data: {
        labels: barData[0],
        datasets: [
          {
            data: barData[1],
            backgroundColor: 'rgba(245, 158, 11)',
            borderColor: 'rgba(245, 158, 11)',
          },
        ],
      },
    });
  };

  return (
    <>
      <canvas
        height="440"
        width="1122"
        style={{ display: 'block', height: '220px', width: '516px' }}
        id="myBarChart"
        ref={barChartRef}
      />
    </>
  );
};

export default BarChart;
